<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放
        </el-col>
        <el-col :span="24" class="imgStyle" align="left">
            <!-- 单选 选项非空 -->
            <div class="optionsHaveValue">
                <img class="imgStyleUrl" v-if="heart.questionDto.detailInfo.questionImgUrl" v-viewer :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
                <div class="styleCent" v-for="(item,i) in heart.questionDto.detailInfo.detailsList" :key="i">
                    <el-radio v-model="advancedRadio" class="opRadio" :label="item.bId" size="medium">&nbsp;</el-radio>
                    <div class="options_A textAlign" @click="advancedRadio=item.bId" v-html="item.msg">{{item.msg}}</div>
                </div>
            </div>
        </el-col>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"judgmentQuestions",
        props: {
            sonData: Object,
            allAnswer: Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                rhythmBeatVal:[],
                timeHer:'',
                advancedRadio:'',
                plays:0,
                answerType:null,
            }
        },
        components:{
            audioStyle
        },
        watch: {
            'advancedRadio':function(now,old){
                if(now&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    })
                })
            },
            'plays':function(now,old){
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            }
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal = []
                this.plays = utils.mottoClone(this.heart.audioPlayTime)
                let heartDto = this.heart.questionDto.detailInfo.detailsList
                heartDto.forEach((ele,i) => {
                    if(ele.msg){
                        ele.msg = this.blea(i)+ utils.dealText(ele.msg)
                    }else{ele.msg = this.blea(i)}
                });
            })
            // 赋值答案
            if(this.allAnswer){
                this.advancedRadio = this.allAnswer.obj.selectIds
                this.answerType = this.allAnswer.obj.answerType
                this.plays = this.allAnswer.playss
            }
        },
        methods:{
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            yesNotProblem(){
                if(this.advancedRadio) return true
                return false
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
            blea(s){
                return s==0? 'A、':s==1? 'B、':s==2? 'C、':s==3? 'D、':''
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 90%;
            box-sizing: border-box;
            padding: 25px 18px;
            
            // 图片单选 选项为空
            .advancedOptions{
                height: 100%;
                .imgStyleUrl{
                    height: 25%;
                    max-width: 85%;
                }
                .styleCent{
                    width: 20%;
                    float: left;
                    margin: 0 2.5%;
                    .opRadio{
                        width: 10%;
                        height: 60px;
                        line-height: 60px;
                        text-align: end;
                        float: left;
                        margin-right: 0;
                    }
                    .options_A{
                        width: 90%;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        background-image: url('../../../static/images/opt.png');
                        background-size: 100% 100%;
                        background-position: 0px 0;
                        float: left;
                    }
                    .opRadio_active{background-image: url('../../../static/images/zhongOpt.png');}
                    .options_A:active{
                        background-image: url('../../../static/images/zhongOpt.png');
                    }
                }
            }
            // 图片单选 选项非为空
            .optionsHaveValue{
                height: 100%;
                .imgStyleUrl{
                    height: 25%;
                    max-width: 85%;
                }
                .styleCent{
                    width: 100%;
                    float: left;
                    margin: 0 0%;
                    .opRadio{
                        width: 40px;
                        height: 60px;
                        line-height: 60px;
                        text-align: end;
                        float: left;
                        margin-right: 0;
                    }
                    .options_A{
                        width: 90%;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        background-image: url('../../../static/images/opt.png');
                        background-size: 103% 100%;
                        background-position: -15px 1px;
                        float: left;
                    }
                    .opRadio_active{background-image: url('../../../static/images/zhongOpt.png');}
                    .options_A:active{
                        background-image: url('../../../static/images/zhongOpt.png');
                    }
                    .textAlign{
                        text-align: left;
                        padding-left: 30px;
                        box-sizing: border-box;
                    }
                }
            }
        }
    }
</style>
<style>
    .styleCent .el-radio__inner{
        height: 18px;
        width: 18px;
    }
    .textAlign .tableimg{
        height: 37px;
        max-height: 37px !important;
        width: 80% !important;

        position: relative;
        display: inline-block;
        vertical-align: middle;
    }
    .textAlign .tableimg img{
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        /* right: 0; */
        bottom: 0;
        left: 0;
        display: block;
        margin: auto 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/judgmentQuestions.vue